export const CREATE_EVENT = 'CREATE_EVENT'
export const UPDATE_EVENT = 'UPDATE_EVENT'
export const DELETE_EVENT = 'DELETE_EVENT'
export const SET_WEEKENDS_ENABLED = 'SET_WEEKENDS_ENABLED'

export const SET_LOADING = 'SET_LOADING'
export const SET_KEY = 'SET_KEY'
export const SET_VOLUME = 'SET_VOLUME'
export const SET_IS_PLAYING = 'SET_IS_PLAYING'

export const RECORD_ERRORS = 'RECORD_ERRORS'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'
export const SET_IS_ONLINE = 'SET_IS_ONLINE'
export const SET_EMAIL = 'SET_EMAIL'
export const CLEAR_AUTH_INFO = 'CLEAR_AUTH_INFO'
export const SET_AUTH_INFO = 'SET_AUTH_INFO'
export const SET_AUTH_USER = 'SET_AUTH_USER'

//STATION INFO
export const SET_STATION_INFO = 'SET_STATION_INFO'
export const SELECT_STATION = 'SELECT_STATION'
export const CLEAR_STATION_ID = 'CLEAR_STATION_ID'

//DASHBOARD
export const SET_STATS = 'SET_STATS'
export const SET_LISTENERS = 'SET_LISTENERS'
export const SET_LISTENER_REPORT = 'SET_LISTENER_REPORT'


//USER
export const SET_ALL_USERS = 'SET_ALL_USERS'
export const SET_USER = 'SET_USER'

//MEDIA FILE
export const SET_MEDIA_FILES = 'SET_MEDIA_FILES'

//PLAYLISTS
export const SET_PLAYLISTS = 'SET_PLAYLISTS'


//SETTINGS
export const SET_PLANS = 'SET_PLANS'
export const SET_INVOICES = 'SET_INVOICES'